import {MaybeRef, toValue} from "vue";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";

export interface NamaVueWidget {
  focus?: (args?: NamaNavigationArgs) => void;
  title?: string;
  canReceiveFocus?: () => boolean;
}

export interface NamaVueWidgetContainer {
  widget: NamaVueWidget;
  index: number;
}

export interface NamaNavigationArgs {
  keyboardEvent: KeyboardEvent;
}

export type NamaNavigateToNextEmit = { (e: "navigateToNext", args: NamaNavigationArgs): void; }

export function commonFocus(refList: NamaVueWidgetContainer[], args: NamaNavigationArgs, noCandidateHandler: () => void): void {
  if (args && args.keyboardEvent.shiftKey)
    navigateBackward(refList, args, refList.length, noCandidateHandler);
  else
    navigateForward(refList, args, -1, noCandidateHandler);

}

export function commonCanReceiveFocus(refList: NamaVueWidgetContainer[]): boolean {
  for (let r of refList) {
    if (!r.widget.canReceiveFocus)
      continue;
    if (r.widget.canReceiveFocus())
      return true;
  }
  return false;
}

export function commonNavigateToNext(refList: NamaVueWidgetContainer[], args: NamaNavigationArgs, index: number, noCandidateHandler: () => void) {
  if (args.keyboardEvent.shiftKey)
    navigateBackward(refList, args, index, noCandidateHandler);
  else
    navigateForward(refList, args, index, noCandidateHandler);
}

function navigateForward(refList: NamaVueWidgetContainer[], args: NamaNavigationArgs, startFrom: number, noCandidateHandler: () => void) {
  let navigated = false;
  for (let i = 0; i < refList.length; i++) {
    let r = refList[i];
    if (!r)
      continue;
    if (r.index <= startFrom)
      continue;
    if (!r.widget.focus)
      continue;
    if (r.widget.canReceiveFocus && !r.widget.canReceiveFocus())
      continue;
    r.widget.focus(args);
    navigated = true;
    break;
  }
  if (!navigated)
    noCandidateHandler();
}

function navigateBackward(refList: NamaVueWidgetContainer[], args: NamaNavigationArgs, startFrom: number, noCandidateHandler: () => void) {
  let navigated = false;
  for (let i = refList.length - 1; i >= 0; i--) {
    let r = refList[i];
    if (!r)
      continue;
    if (r.index >= startFrom)
      continue;
    if (!r.widget.focus)
      continue;
    if (r.widget.canReceiveFocus && !r.widget.canReceiveFocus())
      continue;
    r.widget.focus(args);
    navigated = true;
    break;
  }
  if (!navigated)
    noCandidateHandler();
}

export function addRefToList(refList: NamaVueWidgetContainer[], ref: NamaVueWidgetContainer) {
  if (ref.widget) {
    refList.push(ref);
    refList.sort((a, b) => a.index - b.index);
  } else {
    refList = refList.filter(l => l.index !== ref.index);
  }
  return refList;
}

export function focusAndSelectInput<T extends { focus?(): void; select?(): void; $el?: Element }>(
  inputRef: MaybeRef<T | undefined>
) {
  const input = toValue(inputRef);
  if (!input)
    return;
  input.focus?.();
  if (input.$el)
  GUIUtilities.scrollIntoView(input.$el);
  input.select?.();
}
